document.addEventListener('DOMContentLoaded', () => {

    // --- 1. ACCORDION LOGIC ---
    const accordions = document.querySelectorAll('.accordion-header');
    accordions.forEach(acc => {
        acc.addEventListener('click', function() {
            this.classList.toggle('active');
            const content = this.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    // --- 2. VARIANT SELECTOR & PRICE UPDATE ---
    const selects = document.querySelectorAll('.variant-select');
    selects.forEach(select => {
        select.addEventListener('change', function() {
            const card = this.closest('.product-card');
            
            // 1. Get the price text and Variant ID from the selected option
            const selectedOption = this.options[this.selectedIndex];
            const newPrice = this.value; // Value attribute holds the price
            const newVariantId = selectedOption.getAttribute('data-id'); // data-id holds the ID

            // 2. Update visual Price
            const priceDisplay = card.querySelector('.total-price');
            // Check your currency format here (e.g., $, Dhs., PKR)
            priceDisplay.textContent = 'Dhs. ' + newPrice; 

            // 3. Update the Hidden Input ID (Crucial for Add to Cart)
            const hiddenInput = card.querySelector('.selected-variant-id');
            if(hiddenInput) hiddenInput.value = newVariantId;
        });
    });

    // --- 3. AJAX ADD TO CART LOGIC ---
    const addForms = document.querySelectorAll('form[action="/cart/add"]');

    addForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault(); // Stop page reload

            const btn = this.querySelector('.btn-add');
            const originalText = btn.innerText;
            const variantIdInput = this.querySelector('.selected-variant-id');
            const variantId = variantIdInput ? variantIdInput.value : null;

            if (!variantId) {
                alert("Please select a variant");
                return;
            }

            // Visual Feedback: Loading
            btn.setAttribute('disabled', 'true');
            btn.innerText = 'Adding...';

            // Prepare Data
            const formData = {
                'items': [{
                    'id': variantId,
                    'quantity': 1
                }]
            };

            // Send Request to Shopify API
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                // Visual Feedback: Success
                btn.innerText = 'Added!';
                
                setTimeout(() => {
                    // Reset button after 2 seconds
                    btn.innerText = originalText;
                    btn.removeAttribute('disabled');
                }, 2000);

                // TRIGGER CART DRAWER (Theme Dependent)
                // This looks for common selectors in Dawn, Prestige, Impulse, etc.
                const cartIcon = document.querySelector('a[href="/cart"], .header__icon--cart, .cart-icon, #cart-icon-bubble');
                if (cartIcon) {
                    window.location.href = '/cart';
                } else {
                    // Fallback if no drawer exists -> go to cart page
                    // window.location.href = '/cart';
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                btn.innerText = 'Error';
                setTimeout(() => {
                    btn.innerText = originalText;
                    btn.removeAttribute('disabled');
                }, 2000);
            });
        });
    });

});
